import { Box, Text } from '@cmpsr/components';

type AccountItemProps = {
  label: string;
  value: string;
};

export default function AccountItem({ label, value }: AccountItemProps) {
  return (
    <Box>
      <Text variant="text-body-floating-label-regular" textTransform="uppercase">
        {label}
      </Text>
      <Text variant="text-body-regular" color="text-secondary">
        {value}
      </Text>
    </Box>
  );
}
